import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@app/core/graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    PakmailPickupStatus,
    CreatePakmailPickupStatusInput,
    UpdatePakmailPickupStatusInput,
    DeletePakmailPickupStatusInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class PakmailPickupStatusService {
    private amplifyClient = generateClient();
    constructor() {}

    async listPakmailPickupStatuses(): Promise<PakmailPickupStatus[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPakmailPickupStatuses
                })
            ).data.listPakmailPickupStatuses.items;
            if (data) return data as PakmailPickupStatus[];
        } catch (error) {
            console.error('Error finding listPakmailPickupStatuses:', error);
            return null;
        }
    }

    async createPakmailPickupStatus(
        input: CreatePakmailPickupStatusInput
    ): Promise<PakmailPickupStatus> {
        try {
            const pakmailPickupStatus = (
                await this.amplifyClient.graphql({
                    query: mutations.createPakmailPickupStatus,
                    variables: {
                        input
                    }
                })
            ).data.createPakmailPickupStatus;
            if (pakmailPickupStatus)
                return pakmailPickupStatus as PakmailPickupStatus;
        } catch (error) {
            console.error('Error creating pakmailPickupStatus:', error);
            return null;
        }
    }

    async updatePakmailPickupStatus(
        input: UpdatePakmailPickupStatusInput
    ): Promise<PakmailPickupStatus> {
        try {
            const pakmailPickupStatus = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePakmailPickupStatus,
                    variables: {
                        input
                    }
                })
            ).data.updatePakmailPickupStatus;
            if (pakmailPickupStatus)
                return pakmailPickupStatus as PakmailPickupStatus;
        } catch (error) {
            console.error('Error updating pakmailPickupStatus:', error);
            return null;
        }
    }

    async deletePakmailPickupStatus(
        input: DeletePakmailPickupStatusInput
    ): Promise<PakmailPickupStatus> {
        try {
            const pakmailPickupStatus = (
                await this.amplifyClient.graphql({
                    query: mutations.deletePakmailPickupStatus,
                    variables: {
                        input
                    }
                })
            ).data.deletePakmailPickupStatus;
            if (pakmailPickupStatus)
                return pakmailPickupStatus as PakmailPickupStatus;
        } catch (error) {
            console.error('Error deleting pakmailPickupStatus:', error);
            return null;
        }
    }
}
